import { remoteActionImpactLevelSchema } from './remote-action-impact-level.schema';
import { z } from 'zod/v4';

export const remoteActionSchema = z.object({
  description: z.string().nullable(),
  message: z.string().min(1),
  impactLevel: remoteActionImpactLevelSchema,
});

export type RemoteAction = z.infer<typeof remoteActionSchema>;
